export default {
  please_sel: '請選擇',
  card_title1: '取款',
  local: '香港銀行賬戶取款',
  oversea_tip: '非香港銀行卡取款可能會被銀行拒收並收取一定的手續費，請確認是否取款',
  success: '您的取款申請已經提交，如有問題請與我們聯繫',
  oversea: '非香港銀行賬戶取款',
  card_title2: '最近轉出記錄',
  view_more: '查看更多',
  account_number: '交易賬戶',
  accountNumber: '客戶編碼',
  tradeAccount: '交易賬戶',
  acceptableAmount: '建議最大可提金額',
  available_fund: '可取款額度',
  availableAmount: '可取款額度',
  withdrawal_amount: '取款金額',
  bank_card_number: '銀行卡號',
  confirm_title: '檢查信息',
  confirm_sub_title: '請確認信息並提交信息',
  button_confirm: '確認',
  button_edit: '編輯',
  button_submit: '提交',
  error_withdrawal_amount: '取款金額不得大於對應幣種的可取款額度',
  error_withdrawal_amount_mt5: '取款金額不得大於可用預付款',
  error_withdrawal_check: '還有未處理的取款訂單',
  error_submit: '提交申請失敗',
  error_withdrawal_amount_1: '請填寫取款金額',
  error_withdrawal_amount_2: '金額不能小於0.01',
  error_withdrawal_amount_3: '金額只能輸入2位小數',
  error_withdrawal_amount_total: '取款金額不得大於所有幣種加總的可取額度，預計為{total}',
  error_account_number: '請選擇交易賬戶',
  error_bank_card_number: '請選擇收款賬戶',
  error_withdrawal_name: '請填寫英文名/中文拼音',
  error_withdrawal_bank_name: '請填寫銀行名稱',
  error_withdrawal_bank_card: '請填寫收款賬號',
  error_withdrawal_swift_no: '請填寫Swift代碼',
  error_bank_card_name: '請填寫銀行名稱',
  noWithdrawal: '無取款記錄',
  other_bank_card_name: '銀行名稱',
  other_bank_card_number: '銀行賬號',
  other_bank_card_name_placeholder: '請填寫銀行名稱',
  other_bank_card_number_placeholder: '請填寫銀行賬號',
  note: '提款申請注意事項：</br>' +
    '<b>1、客戶如欲提取交易賬戶內之資金，請提交取款申請。艾德證券期貨將以戶口持有人抬頭發出支票。 </b></br>' +
    '2、艾德證券期貨(“本公司”)的提款申請截止時間一般為星期一至五（香港公眾假期、聖誕前夕、除夕及農曆新年前夕除外）每日下午2時, 任何於下午2時後收到的提款申請將於下一個工作天處理。香港銀行結算日為星期一至五，不包括香港公眾假期、聖誕前夕、除夕及農曆新年前夕。 </br>' +
    '3、艾德證券期貨不接受第三者提款。請確保銀行賬戶姓名與艾德證券期貨開戶申請書上的姓名相符。 </br>' +
    '4、支票的結算時間最少為兩個結算日。香港銀行結算日為星期一至五（香港公眾假期、聖誕前夕、除夕等除外）。 </br>' +
    '5、如欲親身領取支票，請致電 +852 2655 0338 / 400 120 0068（中國內地免費熱線）預約。</br>' +
    '6、如因資料或檔不完整而導致提款申請的處理出現延誤或未能處理該提款申請，或任何其他情況，客戶需自行承擔責任。</br>' +
    '7、反洗錢警告: 如客戶的交易賬戶在存款後沒有進行正常交易活動後作出提款申請，已有可能涉及洗錢活動。艾德證券期貨有可能將賬戶停用或取消。',
  oversea_note: '提款申請注意事項：</br>' +
    '<b>1、艾德證券期貨(“本公司”)的提款申請截止時間一般為星期一至五（香港公眾假期、聖誕前夕、除夕及農曆新年前夕除外）每日下午2時, 任何於下午2時後收到的提款申請將於下一個工作天處理。香港銀行結算日為星期一至五，不包括香港公眾假期、聖誕前夕、除夕及農曆新年前夕。 </b></br>' +
    '2、艾德證券期貨不接受第三者提款。請確保銀行賬戶姓名與艾德證券期貨開戶申請書上的姓名相符。 </br>' +
    '3、如因資料或檔不完整而導致提款申請的處理出現延誤或未能處理該提款申請，或任何其他情況，客戶需自行承擔責任。 </br>' +
    '4、境外提款到賬時間需時較長，請留意收款銀行通知。 </br>' +
    '5、反洗錢警告:如客戶的交易賬戶在存款後沒有進行正常交易活動後作出提款申請，已有可能涉及洗錢活動。艾德證券期貨有可能將賬戶停用或取消。 </br>',
  name: '英文名/中文拼音',
  bankName: '銀行名稱',
  bankNo: '銀行賬戶',
  swiftNo: 'SWIFT Code（銀行國際代碼)',
  withdrawalCare: '銀行可能會收取手續費，費用由客戶自行承擔',
  balanceLow: '沒有餘額',
  error_withdrawal_email: '數據創建成功，郵件發送失敗',
  haveRead: '本人已閱讀，知悉及明白「跨境提款相關費用明細」',
  withdrawalTipsTitle: '跨境提款相關費用明細',
  withdrawalTips: {
    wireTransfer: {
      title: '手續費(銀行及本公司收取)',
      tips: '本公司會一律每次收取港幣350元/美金45元/其他等值貨幣的銀行轉賬手續費。(如收款銀行拒收而出現退回情況，已收取手續費將不予退回) '
    },
    other: {
      title: '其他收費(銀行收取)',
      tips: '銀行有可能收費行政費用,視乎有關銀行的政策而訂。客戶需向其匯款銀行查詢。'
    },
    exchangePriceDifferenceBank: {
      title: '兌換差價(銀行收取)',
      tips: '如客戶取款貨幣與其銀行戶口貨幣不同,當中可能產生兌換差價。',
      example: '如:客戶提取美元到其人民幣銀行戶口，銀行會以其匯率兌換客戶之美元至人民幣，當中可能產生兌換差價。客戶需向其匯款銀行查詢。 '
    },
    exchangePriceDifferenceCompany: {
      title: '兌換差價(本公司收取)',
      tips: '如客戶取款貨幣與其交易賬戶結算貨幣不同,本公司會以本公司適用的銀行匯率兌換其存款為交易賬戶結算貨幣後進行取款,過程中有可能產生兌換差價。 ',
      example: '如:客戶交易賬戶以美元作為結算貨幣，所有港元/人民幣取款將會以本公司適用的銀行匯率兌換成美元並於您的交易賬戶內扣除。 '
    },
    uploadTips: {
      tip1: '如欲提取超過港幣可取款額度的金額，請先自行將其他貨幣現金結餘換匯後再提款，如有需要請聯絡客服',
      mt5Tip: '最終實際提款金額會以港幣匯出，如有其它需要請聯絡客服。 ',
      uploadTitle: '上傳收款銀行證明(必須包含銀行名稱、銀行賬號及閣下姓名全名)',
      tip2: '證明文件可以是：',
      tip3: '1. 印有閣下姓名和銀行賬號的提款卡正面。 ',
      tip4: '2. 印有發出日期（3個月內）的銀行開戶信件；或',
      tip5: '3. 印有發出日期（3個月內）的銀行月結單副本/電子月結單；或',
      tip6: '為了保障您的賬戶安全，如您遞交的證明文件不符合要求，客服會第一時間與您聯繫，如您之前已經遞交過證明文件則不必重複遞交。 '
    }
  },
  irregular_rules_bank_card_number: '銀行卡號只能輸入數字或者-!',
  irregular_rules_bank_card_name: '請輸入正確的銀行名稱!',
  imageKeysIsRequired: '請上傳收款銀行證明!',
  largestAmount: '為降低提款後賬戶資金緊張而短期內出現強制平倉的風險，此為建議最大提取金額。同時，提取之金額不可大於賬戶「可用保證金」金額。 ',
  liquidation: '由於市場價格波動, 轉出目前要求的金額有機會令賬戶在短時間內觸發強制平倉',
  konwtext: '我明白市場價格波動有可能導致賬戶在提款過程中或之後觸發強制平倉, 我了解並接受相關之風險, 請繼續轉出資金。',
  checkInfo: '請先點擊勾選項',
  bandBank: '本人確認將此銀行登記為出金綁定銀行',
  warnBandBank: '注：如因任何原因導致此次出金失敗，將不會為閣下綁定此銀行。',
  otherTip: `<div style="margin-top: 4px;">{}.如閣下收款銀行地區為澳洲但未有填寫收款銀行位址，若發生銀行退款，可能導致退款時間延長。</div>`,
  unhkServiceFee: '銀行轉賬手續費',
  actualAmountCredited: '(*實際到賬金額以銀行為準)'
}
